module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [(_vm.multiple) ? _c('selected-appointments-preview', {
    staticClass: "mb-2",
    attrs: {
      "appointment-ids": _vm.appointmentIds,
      "flat": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t('text.label')))]), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.successMessage,
      "color": "success",
      "type": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('messages.success')) + "\n    ")]), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": _vm.errorMessage,
      "color": "success",
      "type": "error",
      "dismissible": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('messages.error')) + "\n    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hint": _vm.$t("text.hint"),
      "persistent-hint": "",
      "solo": "",
      "prepend-icon": "tag"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _vm._l((_vm.tags), function(tag, index) {
    return [(tag) ? _c('v-chip', {
      key: (tag + "-" + index),
      attrs: {
        "color": "primary",
        "dark": "",
        "small": "",
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.remove(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('buttons.done')) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.addRequest.loading,
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.save')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16dad28a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/Tag.vue
// module id = 1340
// module chunks = 9